import { useTranslation } from "react-i18next";
import Footer from "../../../../components/footer/Footer";
import Navbar from "../../../../components/navbar/navbar";
import TitleSection from "../../../../components/title-section/title-section";
import AddServItem from "../add-serv-item/add-serv-item";
import './main.css'
import additionalIcon from '../../../../assets/imgs/services/additional/additional_icon.svg';
import deliveryIcon from '../../../../assets/imgs/services/additional/delivery_icon.svg';
import packageIcon from '../../../../assets/imgs/services/additional/package_icon.svg';
import storageIcon from '../../../../assets/imgs/services/additional/storage_icon.svg';
import valuationIcon from '../../../../assets/imgs/services/additional/valuation_icon.svg';
import phoneIcon from "../../../../assets/imgs/services/international/telephone-icon.svg";
import {
  FaTruck,
  FaDropbox,
  FaWarehouse,
  FaCoins,
  FaPhoneAlt,
} from "react-icons/fa";
import React from "react";
import { Link } from "react-router-dom";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import Helmet from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import BreadCrumb from "../../../../components/breadcrumb/breadcrumb";

function AddServicesMain() {
  const [tNabvar] = useTranslation("navbar");
  const [tGeneral] = useTranslation("generalPage");
  const [tSMetaData] = useTranslation("metaData");
  const [tAddServ] = useTranslation("additionalServPage");
  const iconComponents = {
    FaTruck,
    FaDropbox,
    FaWarehouse,
    FaCoins,
  };

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[2]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[2]
    }`
  );

  const cardsData = [
    {
      id: 1,
      title: tAddServ("home-delivery.title"),
      icon: deliveryIcon, // Reemplaza con tu import
      description: tAddServ("home-delivery.description")
    },
    {
      id: 2,
      title: tAddServ("packaging.title"),
      icon: packageIcon,
      description: tAddServ("packaging.description")
    },
    {
      id: 3,
      title: tAddServ("storage.title"),
      icon: storageIcon,
      description: tAddServ("storage.description")
    },
    {
      id: 4,
      title: tAddServ("valuation.title"),
      icon: valuationIcon,
      description: tAddServ("valuation.description")
    }
  ];

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>{tSMetaData("serviciosAdicionales.title")}</title>
        <meta
          name="description"
          content={tSMetaData("serviciosAdicionales.description")}
        />
      </Helmet>
      <Navbar />
      <BreadCrumb />
      {/* <TitleSection title={tAddServ("header.title")} />
      <div className="container">
        <div className="row" style={{ marginTop: "30px" }}>
          <div className="col-12 col-md-6">
            <AddServItem
              icon={React.createElement(iconComponents.FaTruck)}
              title={tAddServ("home-delivery.title")}
              description={tAddServ("home-delivery.description")}
            />
          </div>

          <div className="col-12 col-md-6">
            <AddServItem
              icon={React.createElement(iconComponents.FaDropbox)}
              title={tAddServ("packaging.title")}
              description={tAddServ("packaging.description")}
            />
          </div>

          <div className="col-12 col-md-6">
            <AddServItem
              icon={React.createElement(iconComponents.FaWarehouse)}
              title={tAddServ("storage.title")}
              description={tAddServ("storage.description")}
            />
          </div>

          <div className="col-12 col-md-6">
            <AddServItem
              icon={React.createElement(iconComponents.FaCoins)}
              title={tAddServ("valuation.title")}
              description={tAddServ("valuation.description")}
            />
          </div>
        </div>

        <div className="divider"></div>

        <div className="more-information-container">
          <div className="more-information">
            <i>
              <FaPhoneAlt />
            </i>
            <h4>{tAddServ("more-info.more-info")}</h4>
          </div>
          <p>{tAddServ("more-info.description")}</p>
          <Link
            id="btnContactAdditionalServices"
            to={`/${tNabvar("category-services.contact")}`}
          >
            <button>{tAddServ("more-info.btn-text")}</button>
          </Link>
        </div>
      </div> */}
      {/* <div className="container-fluid bg-blue-light">
        <div className="container">
          <div className="row">
            <div className="col additional-bar">
              <img src={additionalIcon} alt="Servicios Adicionales" className="additional-icon" />
              <span className="uppercase">{tAddServ("header.title")}</span>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container additional-cards-container">
        <div className="row g-5">
          {cardsData.map((card) => (
            <div className="col-12 col-md-6 col-xl-3" key={card.id}>
              {/* h-100 hace que todas las cards tengan la misma altura */}
              <div className="h-100 border-0 additional-card">
                <div className="additional-card-body">
                  <div className="mb-4">
                    <img src={card.icon} className="additional-card-icon" alt={card.title} />
                  </div>
                  <h4 className="additional-card-title">
                    {card.title}
                  </h4>
                  <div className="additional-card-text">
                    {card.description}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row my-5">
          <div className="col d-flex flex-column align-items-center">
            <h5 className="add-more-info">{tAddServ("more-info.more-info")}</h5>
            <span className="add-our-services">{tAddServ("more-info.description")}</span>
            <Link to={tGeneral("link-contact")} className="btn-contact-seller">
              <img src={phoneIcon} alt="Phone Icon" />
              <span>{tGeneral("header.contact-sales")}</span>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AddServicesMain;
